// Angular
import {NgModule, inject, provideAppInitializer, ErrorHandler} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { FileSizePipe } from './utils/file-size.pipe';
// Keycloak
import { AppRoutingModule } from './app-routing.module';
import { KeycloakAngularModule, KeycloakService } from 'keycloak-angular';

//Tracking
import './plausible';
import './appsignal';
import { AppsignalErrorHandler } from './errors/appsignal-error.handler';
import { HttpErrorInterceptor } from './errors/http-error.interceptor';

// Custom
import { TabHomeComponent } from './tabs/tab-home/tab-home.component';
import { TabPassPredictionComponent } from './tabs/tab-pass-prediction/tab-pass-prediction.component';
import { TabDevicesComponent } from './tabs/tab-devices/tab-devices.component';
import { TabGatewaysComponent } from './tabs/tab-gateways/tab-gateways.component';
import { TabSystemStatusComponent } from './tabs/tab-system-status/tab-system-status.component';
import { TabAlmanacComponent } from './tabs/tab-almanac/tab-almanac.component';
import { TopNavComponent } from './top-nav/top-nav.component';
import { initializeKeycloak } from './auth-init/auth-init';
import { NotFoundComponent } from './not-found/not-found.component';
import { ApiService } from './services/api.service';
import { InfoMessageComponent } from './info-message/info-message.component';
import { MotdComponent } from './motd/motd.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { DeleteDeviceDialogComponent } from './delete-device-dialog/delete-device-dialog.component';
import { NotAllowedComponent } from './not-allowed/not-allowed.component';
import { CheckboxGroupComponent } from './checkbox-group/checkbox-group.component';
import { DeviceDialogComponent } from './device-dialog/device-dialog.component';
import { GridComponent } from './shared-components/grid/grid.component';
import { InfoAreaComponent } from './shared-components/info-area/info-area.component';
import { ContentAreaComponent } from './shared-components/content-area/content-area.component';
import { MessagesComponent } from './home/messages/messages.component';
import {LoadingComponent} from "./shared-components/loading/loading.component";
import {NoMessagesComponent} from "./shared-components/no-messages/no-messages.component";
import { GetStartedWithMultinodeComponent } from './home/get-started-with-multinode/get-started-with-multinode.component';
import { GetStartedComponent } from './home/get-started/get-started.component';
import { PaginationComponent } from './shared-components/pagination/pagination.component';
import { SortableHeaderComponent } from './shared-components/sortable-header.component';


// Material
import {MatTabsModule} from '@angular/material/tabs';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatCardModule} from '@angular/material/card';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatDividerModule} from '@angular/material/divider';
import {MatTableModule} from '@angular/material/table';
import {MatSelectModule} from '@angular/material/select';
import {MatBadgeModule} from '@angular/material/badge';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatListModule} from '@angular/material/list';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatDialogModule} from '@angular/material/dialog';
import {MatRadioModule} from '@angular/material/radio';
import {MatSortModule } from '@angular/material/sort';
import {MatTreeModule} from '@angular/material/tree';
import { TabDownloadsComponent } from './tabs/tab-downloads/tab-downloads.component'
import { TabSubscriptionsComponent } from './tabs/tab-subscriptions/tab-subscriptions.component'
import { TabSubscriptionsBuyComponent } from './tabs/tab-subscriptions/tab-subscriptions-buy.component'
import { TabSubscriptionsFleetComponent } from './tabs/tab-subscriptions/tab-subscriptions-fleet.component'
import { ContactSalesComponent } from './tabs/tab-subscriptions/contact-sales.component'
import {KeyPairDialogComponent} from "./key-pair-dialog/key-pair-dialog.component";
import {GatewayDialogComponent} from "./gateway-dialog/gateway-dialog.component";
import {DeleteGatewayDialogComponent} from "./delete-gateway-dialog/delete-gateway-dialog.component";

@NgModule({ declarations: [
        AppComponent,
        TabHomeComponent,
        TabPassPredictionComponent,
        TabDevicesComponent,
        TabGatewaysComponent,
        TabSystemStatusComponent,
        TabAlmanacComponent,
        TopNavComponent,
        NotFoundComponent,
        InfoMessageComponent,
        MotdComponent,
        DeleteDeviceDialogComponent,
        DeleteGatewayDialogComponent,
        GatewayDialogComponent,
        NotAllowedComponent,
        CheckboxGroupComponent,
        DeviceDialogComponent,
        KeyPairDialogComponent,
        TabDownloadsComponent,
        TabSubscriptionsComponent,
        TabSubscriptionsBuyComponent,
        TabSubscriptionsFleetComponent,
        ContactSalesComponent,
        FileSizePipe,
        GridComponent,
        InfoAreaComponent,
        ContentAreaComponent,
    MessagesComponent,
    LoadingComponent,
    NoMessagesComponent,
    GetStartedWithMultinodeComponent,
        GetStartedComponent,
        PaginationComponent,
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        KeycloakAngularModule,
        ClipboardModule,
        MatTabsModule,
        MatButtonModule,
        MatIconModule,
        MatCardModule,
        MatToolbarModule,
        MatInputModule,
        ReactiveFormsModule,
        FormsModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatDividerModule,
        MatTableModule,
        MatSelectModule,
        MatBadgeModule,
        MatTooltipModule,
        MatListModule,
        MatSnackBarModule,
        MatAutocompleteModule,
        MatCheckboxModule,
        MatDialogModule,
        MatRadioModule,
        MatSortModule,
        MatTreeModule,
        SortableHeaderComponent], providers: [provideAppInitializer(() => {
        const initializerFn = (initializeKeycloak)(inject(KeycloakService));
        return initializerFn();
      }),
        ApiService,
        provideHttpClient(withInterceptorsFromDi()),
        { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
        { provide: ErrorHandler, useClass: AppsignalErrorHandler }] })
export class AppModule { }
